import { FormSelectOption } from '../../form-controls/entities/form-select-option.entity';
import { MultiFormSelectOptions } from '../../form-controls/entities/multi-form-select-options.entity';

export function multiFormSelectOptionWrapper<T>(
    formSelectOptions: FormSelectOption<T>[] | undefined,
    isLiveData: boolean = false
): MultiFormSelectOptions<T> {
    return { isLiveData, options: formSelectOptions || [] };
}
